export default __webpack_public_path__ + "13b6e29aae9f410db37ce32499e49671.svg";